export default {
  List: {
    OrganizationUnit: "Cơ cấu tổ chức",
    AddButton: "Thêm mới",
    SearchPlaceHolder: "Tìm kiếm cơ cấu tổ chức",
    OrganizationUnitName: "Tên đơn vị",
    OrganizationUnitCode: "Mã đơn vị",
    OrganizationUnitType: "Cấp tổ chức",
    Address: "Địa chỉ",
    status: "Trạng thái",
    OrgParent: "Thuộc đơn vị",
    ShortCutName: "Tên viết tắt",
    Parent: "Trực thuộc",
    AssetUsing: "TS đang sử dụng",
    UserManager: "Người quản lý",
    Organization: "Phòng ban",
    Description: "Diễn giải",
    SynchFromAMIS: "Đồng bộ từ AMIS",
    SynchFromAMISTitle: "Đồng bộ từ AMIS hệ thống",
    WorkingRun: "Đang thực hiện đồng bộ dữ liệu từ Amis hệ thống",
    SynchSuccess: "Đồng bộ thành công",
    Management: "Đơn vị quản lý",
  },
  Detail: {
    AddTitle: "Thêm mới cơ cấu tổ chức",
    EditTitle: "Sửa đổi cơ cấu tổ chức",
    ParentOrganization: "Thuộc đơn vị",
    note: "Ghi chú",
    OrganizationUnitInformation: "Thông tin phòng ban",
    OrganizationUnitUsingInformation: "Thông tin phòng ban sử dụng",
    IsManagement: "Là đơn vị quản lý",
    InActive: "Ngừng theo dõi",
  },
  OrganizationUnitType: {
    AddTitle: "Thêm mới cấp tổ chức",
    OrganizationUnitTypeName: "Cấp tổ chức",
    Description: "Diễn giả",
    SortOrder: "Thứ tự",
  },
  Allocation: {
    OrganizationUnitName: "Tên phòng ban",
    Dependent: "Trực thuộc",
    Representative: "Người đại diện",
  },
  Reduce: {
    ReduceOrganization: "Thu hồi theo phòng ban",
    ReduceAsset: "Tài sản được thu hồi",
    ReduceAssetInformation: "Thông tin thu hồi",
    ProcessDate: "Ngày thu hồi",
    Reason: "Lý do thu hồi",
    FileName: "Tệp đính kèm",
  },
};
